import API from "../../apiConfig";

export const fetchOrders = async (data) => {
  const response = await API.get("gostor/orders/sellerOrders", { params: data });
  return response;
};
export const fetchBrands = async (data) => {
  const response = await API.get("products/v1/brands", { params: data });
  return response;
};
export const getShippingLabel = async (data) => {
  const response = await API.get("gostor/orders/getShippingLabel", { params: data });
  return response;
};
export const acceptOrders = async (data) => {
  const response = await API.post("gostor/orders/accept", data);
  return response;
};
export const postInvoice = async (data) => {
  const response = await API.post("gostor/invoices/generate", data);
  return response;
};
export const reGenInvoice = async (data) => {
  const response = await API.post("gostor/invoices/regenerate", data);
  return response;
};
export const readyToShip = async (data) => {
  const response = await API.post("logistics/readyToShip", data);
  return response;
};
export const updateSelfDeliveryStatus = async (data) => {
  const response = await API.post("logistics/support/status", data);
  return response;
};